import { render, staticRenderFns } from "./DevImageBlock.vue?vue&type=template&id=25d3f50e&scoped=true&"
import script from "./DevImageBlock.vue?vue&type=script&lang=js&"
export * from "./DevImageBlock.vue?vue&type=script&lang=js&"
import style0 from "./DevImageBlock.vue?vue&type=style&index=0&id=25d3f50e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d3f50e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VInput } from 'vuetify/lib/components/VInput';
installComponents(component, {VDialog,VInput})
